import { Ajax } from './Ajax';
import { environmentMap } from 'constants/applicationConstant';
import uriConstants from 'constants/uriConstants';

export default async ({ organisationId, }) => {
    const data = await Ajax.get(`${uriConstants.CASTOKENURI}${organisationId}`);
    if (data.status === 200) {
        const { data: { token="" } } = data;
        if (token) {
            return token;
        }
    }
    return null;
}
